module.exports = __webpack_public_path__ + "static/media/icon3_roll.bf8b3270.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/Homepage/icon3_roll.png
// module id = 347
// module chunks = 0